import { observer } from 'mobx-react-lite';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import { getActivityFeedStore } from '../store/store';
import saveActivityFeedSettings from '../utils/saveActivityFeedSettings';
import {
    activityFeedMainTitle,
    backButtonTitleString,
} from './ActivityFeedSettings.locstring.json';
import loc from 'owa-localize';

const styles = require('./ActivityFeedSettings.scss');

export default observer(function ActivityFeedTitle() {
    return (
        <div className={styles.container}>
            <div className={styles.headerControl}>
                {getActivityFeedStore().isActivityFeedSettingOpen ? (
                    <ActionButton
                        className={styles.backButton}
                        styles={{
                            icon: styles.backButtonIcon,
                        }}
                        text={loc(backButtonTitleString)}
                        title={loc(backButtonTitleString)}
                        onClick={saveActivityFeedSettings}
                        iconProps={{ iconName: ControlIcons.Back }}
                    />
                ) : (
                    <h2 className={styles.notificationTitle}>{loc(activityFeedMainTitle)}</h2>
                )}
            </div>
        </div>
    );
});
